<script setup lang="ts">
import { computed } from 'vue'
import { useAdmin } from '@/stores/admin'

const props = defineProps<{
  code: string | null
  size?: 'sm' | 'md' | 'lg'
}>()

const admin = useAdmin()

const emoji = computed(() => {
  if (!props.code) return '🌐'
  return admin.countries.find((c) => c.code === props.code)?.emoji || props.code
})

const title = computed(() => {
  if (!props.code) return 'Global (MAX)'
  const country = admin.countries.find((c) => c.code === props.code)
  return country?.name_en || props.code
})

const sizeClass = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'text-sm'
    case 'lg':
      return 'text-lg'
    default:
      return 'text-base'
  }
})
</script>

<template>
  <span :class="['leading-tight', sizeClass]" :title="title">{{ emoji }}</span>
</template>
